"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.RequiredIntermediateFieldIterable = void 0;
// Inputs namespace converted to module
const _imports_1 = require("../_imports");
const _shared_1 = require("../_shared");
// ************   INTERMEDIATE FIELDS   ************
exports.RequiredIntermediateFieldIterable = _imports_1.z.enum([
    'accrualDate', // Represents the actual date of accrual, determined by accrual schedule
    'accrualValue', // Output used for final accrual amount
]);
const CalcFormulaConfigSchema = _shared_1.FormulaConfigSchema.and(_imports_1.z.object({ type: _imports_1.z.literal('formula') }));
const IntermediateFieldSchema = _imports_1.z.object({
    field: _imports_1.z.string(),
    config: CalcFormulaConfigSchema,
});
// ************   CONFIG   ************
// Multiple configurations can be applied as an array to the same account
// Accrual dates act as separate segments using start/end date properties
// i.e. Original config from date A -> B, then amended config from B -> C
exports.ConfigSchema = _imports_1.z.object({
    accrualDates: _imports_1.RecurringDate.ConfigSchema,
    dataAccessors: _imports_1.z.array(_imports_1.z.any()), // to be replaced
    intermediateFields: _imports_1.z.array(IntermediateFieldSchema),
});
//# sourceMappingURL=Inputs.js.map